let optionsTrainingRegion = {
  legend: {
    display: false,
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || ""

        if (label) {
          label += ": "
        }

        label += parseFloat(tooltipItem.yLabel).toLocaleString()

        return label
      },
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 6000,
          maxTicksLimit: 4,
          callback: function (num) {
            return num > 1
              ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
              : num
          },
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsTrainingIncome = {
  legend: {
    display: false,
  },
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || ""

        if (label) {
          label += ": "
        }

        label += parseFloat(tooltipItem.yLabel).toLocaleString()

        return label
      },
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 10000,
          maxTicksLimit: 8,
          callback: function (num) {
            return num > 1
              ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
              : num
          },
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsCDRegion = {
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 45,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsCDIncome = {
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 60,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let optionsCDTopic = {
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 40,
        },
      },
    ],
    xAxes: [
      {
        gridLines: {
          display: false,
        },
      },
    ],
  },
}

let chartData = [
  {
    id: "share-of-spending",
    data: {
      labels: [
        "Bilateral Surveillance",
        "Multilateral Surveillance",
        "Technical Assistance",
        "Training",
        "Oversight of global systems",
        "Lending",
        "Miscellaneous",
      ],
      datasets: [
        {
          data: [23.1, 19.1, 24.1, 4.7, 10.9, 14.8, 3.3],
          backgroundColor: [
            "#5EB245",
            "#5EB245",
            "#5EB245",
            "#5EB245",
            "#5EB245",
            "#5EB245",
            "#5EB245",
            "#5EB245",
          ],
          barThickness: 8,
        },
      ],
    },
    options: {
      legend: {
        display: false,
      },
      layout: {
        padding: {
          bottom: 10,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              callback: function (value, index, values) {
                return value + "%"
              },
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
            },
          },
        ],
      },
    },
  },
  {
    id: "spending-on-capacity-development",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          label: "Fund Financed",
          borderColor: "#008FC4",
          backgroundColor: "#008FC4",
          data: [130, 132, 138, 140, 139],
          barThickness: 8,
        },
        {
          label: "Externally Financed",
          borderColor: "#5EB245",
          backgroundColor: "#5EB245",
          data: [134, 142, 173, 176, 166],
          barThickness: 8,
        },
      ],
    },
    options: {
      height: "large",
      scales: {
        xAxes: [
          {
            stacked: true,
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            stacked: true,
            ticks: {
              callback: function (value, index, values) {
                return "$" + value
              },
            },
          },
        ],
      },
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 10,
          padding: 20,
        },
      },
    },
  },
  {
    id: "capacity-africa",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [38.2, 40.8, 37.9, 39.2, 39.1],
          borderColor: "#008FC4",
          backgroundColor: "#008FC4",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-asia",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [19.9, 17.1, 21.4, 24.6, 25.5],
          borderColor: "#008FC4",
          backgroundColor: "#008FC4",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-europe",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [10.3, 11.1, 10.6, 8.5, 9.2],
          borderColor: "#008FC4",
          backgroundColor: "#008FC4",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-middle-east",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [14.6, 14.8, 14.7, 14.3, 13.5],
          borderColor: "#008FC4",
          backgroundColor: "#008FC4",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-western-hemisphere",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [17.1, 16.2, 15.4, 13.3, 12.7],
          borderColor: "#008FC4",
          backgroundColor: "#008FC4",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDRegion,
  },
  {
    id: "capacity-income-advanced",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [3.4, 3.6, 3.1, 3.3, 3.3],
          borderColor: "#5EB245",
          backgroundColor: "#5EB245",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDIncome,
  },
  {
    id: "capacity-income-emerging",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [48.4, 46.1, 47.4, 44.3, 45.0],
          borderColor: "#5EB245",
          backgroundColor: "#5EB245",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDIncome,
  },
  {
    id: "capacity-income-low",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [48.3, 50.3, 49.5, 52.4, 51.6],
          borderColor: "#5EB245",
          backgroundColor: "#5EB245",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDIncome,
  },
  {
    id: "capacity-topic-public",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [34.6, 36.1, 37.1, 36.7, 36.7],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-monetary",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [19, 18.2, 18.3, 17.6, 17.6],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-statistics",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [10.9, 11.0, 11.8, 13.3, 13.3],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-legal",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [4.7, 4.9, 4.5, 3.9, 3.9],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-macroeconomic",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [30.9, 29.9, 28.2, 28.4, 28.4],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "capacity-topic-legal",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [4.7, 4.9, 4.5, 3.9, 3.9],
          borderColor: "#8A8B8A",
          backgroundColor: "#8A8B8A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsCDTopic,
  },
  {
    id: "training-advanced",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [1044, 784, 747, 853, 915],
          borderColor: "#BDABC7",
          backgroundColor: "#BDABC7",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingIncome,
  },
  {
    id: "training-emerging",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [7790, 7295, 9185, 8800, 8258],
          borderColor: "#BDABC7",
          backgroundColor: "#BDABC7",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingIncome,
  },
  {
    id: "training-low-income",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [5328, 5520, 6283, 7015, 6036],
          borderColor: "#BDABC7",
          backgroundColor: "#BDABC7",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingIncome,
  },
  {
    id: "training-africa",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [3996, 4353, 4711, 4948, 4060],
          borderColor: "#F1AF2A",
          backgroundColor: "#F1AF2A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-asia",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [2882, 2504, 3674, 4284, 4440],
          borderColor: "#F1AF2A",
          backgroundColor: "#F1AF2A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-europe",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [2077, 1809, 1815, 1613, 1548],
          borderColor: "#F1AF2A",
          backgroundColor: "#F1AF2A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-middle-east",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [2552, 2831, 3524, 3402, 2966],
          borderColor: "#F1AF2A",
          backgroundColor: "#F1AF2A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
  {
    id: "training-western-hemisphere",
    data: {
      labels: ["2016", "2017", "2018", "2019", "2020"],
      datasets: [
        {
          data: [2961, 2328, 2873, 2746, 2528],
          borderColor: "#F1AF2A",
          backgroundColor: "#F1AF2A",
          fill: false,
          barThickness: 8,
        },
      ],
    },
    options: optionsTrainingRegion,
  },
]

export default chartData
